export default [
  {
    path: '/upgradePackageIndex',
    name: 'upgradePackageIndex',
    component: () => import('@/views/publicView/deviceUpgrade/package/index'),
    meta: {
      title: '设备升级包',
      isAlive: true
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/upgradePackage.js